"use client"

import { AuthProvider } from "@/core/providers/auth.provider";
import { LoadingProvider } from "@/core/providers/loading.provider";
import { ReactNode, useState } from "react";
import { QueryClient, QueryClientProvider, MutationCache } from "@tanstack/react-query";
import dynamic from "next/dynamic";
import { Toaster, toast } from "sonner";

const WalletProvider = dynamic(
    () => import("@/core/providers/wallet.provider").then((mod) => mod.WalletProvider),
    { ssr: false }
);

type Props = {
    children: ReactNode;
    initialJwt?: string
}

const Providers = ({
    children,
    initialJwt,
}: Props) => {
    const [queryClient] = useState(() => new QueryClient({
        mutationCache: new MutationCache({
            onSuccess: (data: any) => {
                const message = data?.header?.message;
                if (message) {
                    toast.success(message);
                }
            },
            onError: (error: any) => {
                toast.error(error?.message || "Action failed");
            },
        }),
    }));

    return (
        <QueryClientProvider data-component-id="src/app/providers.tsx:39:8" data-component-path="src/app/providers.tsx" data-component-line="39" data-component-end-line="48" data-component-file="providers.tsx" data-component-name="QueryClientProvider" data-component-content="%7B%22elementName%22%3A%22QueryClientProvider%22%7D" client={queryClient}>
            <LoadingProvider data-component-id="src/app/providers.tsx:40:12" data-component-path="src/app/providers.tsx" data-component-line="40" data-component-end-line="47" data-component-file="providers.tsx" data-component-name="LoadingProvider" data-component-content="%7B%22elementName%22%3A%22LoadingProvider%22%7D">
                <WalletProvider data-component-id="src/app/providers.tsx:41:16" data-component-path="src/app/providers.tsx" data-component-line="41" data-component-end-line="46" data-component-file="providers.tsx" data-component-name="WalletProvider" data-component-content="%7B%22elementName%22%3A%22WalletProvider%22%7D">
                    <AuthProvider data-component-id="src/app/providers.tsx:42:20" data-component-path="src/app/providers.tsx" data-component-line="42" data-component-end-line="45" data-component-file="providers.tsx" data-component-name="AuthProvider" data-component-content="%7B%22elementName%22%3A%22AuthProvider%22%7D" initialJwt={initialJwt}>
                        {children}
                        <Toaster data-component-id="src/app/providers.tsx:44:24" data-component-path="src/app/providers.tsx" data-component-line="44" data-component-end-line="44" data-component-file="providers.tsx" data-component-name="Toaster" data-component-content="%7B%22elementName%22%3A%22Toaster%22%7D" position="top-right" richColors closeButton />
                    </AuthProvider>
                </WalletProvider>
            </LoadingProvider>
        </QueryClientProvider>
    )
}

export default Providers